import Button from '../../../../components/ui/Button';

/**
 * What the group drill-down shows when there is no matching group.
 *
 * Rendering nothing is never an option: the tech is left staring at an empty body
 * with no way to tell what happened.
 *
 * Props:
 *   assetsLoading      — is the asset query loading
 *   searchValue        — current equipment-code search term
 *   groupCount         — how many groups the session currently has
 *   activeGroup        — the group name that was open, if any
 *   onClearSearch      — clear the search term
 *   onBackToGroupList  — return to the board list
 */
export default function MissingGroupState({
  assetsLoading = false,
  searchValue = '',
  groupCount = 0,
  activeGroup = null,
  onClearSearch,
  onBackToGroupList,
}) {
  // Which "no group to show" case are we in?
  // keepPreviousData keeps assetsLoading false on a refetch, so an empty group list
  // is itself the signal that a pager reset is still refilling page by page.
  const missingGroupState = assetsLoading
    ? 'loading'
    : searchValue?.trim()
      ? 'no-match'
      : groupCount === 0
        ? 'loading'
        : 'gone';

  return (
    <div className="mobile-group-list">
      {missingGroupState === 'loading' && (
        <p className="mobile-group-list__empty">Loading assets…</p>
      )}

      {missingGroupState === 'no-match' && (
        <>
          <p className="mobile-group-list__empty">
            No circuits match that search{activeGroup ? ` in ${activeGroup}` : ''}.
          </p>
          <Button variant="outline" onClick={onClearSearch}>
            Clear search
          </Button>
        </>
      )}

      {missingGroupState === 'gone' && (
        <>
          <p className="mobile-group-list__empty">
            {activeGroup ? `${activeGroup} is` : 'That group is'} no longer in this session.
          </p>
          <Button variant="outline" onClick={onBackToGroupList}>
            Back to all groups
          </Button>
        </>
      )}
    </div>
  );
}
